/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const timelineMetricsSchema = z.object({
  timelineEndDate: z.iso.date(),
  timelineStartDate: z.iso.date(),
});
